import { AddressModel } from './address.model';
import { StatusDate } from './status-date.model';
import { Cart } from './cart.model';
import { OrderMeasurement } from './order-measurement.model';
import { Coupon } from './coupon.model';
import { ComboOffer } from './combo-offer.model';
import { CourierCofig } from './courierConfig.model';
export class B2COrderModel {
        _id: string;
        customerId: string;
        orderId: string;
        customer: any;
        total: number;
        initiatedTotal: number;
        addressDetails: [ AddressModel ];
        paymentStatus: string;
        paypalStatus: string;
        orderStatus: string;
        orderDate: Date;
        incrementRate: number;
        cancelOrderDate: Date;
        durationForCancel: Date;
        statusDate: [ StatusDate ];
        orderTime: string;
        orderUpdatedDate: Date;
        shipingFees: number;
        currencyCode: string;
        countryCode: string;
        currencyRate: number;
        razorPayOrderId: string;
        // product details
        orderedProducts: [ Cart ];
      
        // payment details
        razorpayPaymentId: string;
        razorpaySignature: string;
        paymentMode: string;
        comboOfferAmount: number;
        comboOffer: [ComboOffer];
        awbNo: string;
        shipmentStatus: string;
        walletAmount: number;
        cancellationRefund: number;
        isCancelRefund: boolean;
        paypalOrderId: string;
        purchaseOrderStatus: string;
        gstNumber: string;
        companyName: string;
        confirmationOrderStatus: string;
        isGiftWrapping: boolean;
        giftMessage: {
                sendor: string,
                receiver: string,
                message: string,
                amount: number
        };
        shippingigst: string;
        shippingcgst: string;
        shippingsgst: string;
        orderOffer: [string];
        courierId: CourierCofig;
        trackingNo: string;
        // coupon details
        coupon: [Coupon];
        cancelCoupon: boolean;
        invoiceID: string;
        invoiceDate: Date;
        codChargeAmount: number;
        measurement: [OrderMeasurement];
        gstDetails: [{
                labelName: String,
                minPrice: Number,
                sgst: Number,
                cgst: Number,
                igst: Number,
                minsgst: Number,
                mincgst: Number,
                minigst: Number,
                autoCalculate: Boolean,
                createdDate: Date
        }];
}